import {SxProps, Theme} from '@mui/material';

/** Kept for the back-office person page, which still lays its two panels out in a Grid. */
export const gridElementSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
};

export const pageSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    // Clears the app bar, as every other detail page does now that its header lives in the first card.
    mt: 2.5,
};

/**
 * The person and their links, level with each other.
 *
 * `stretch` rather than `start`: both cards are columns whose last block grows, so the row ends flat
 * whichever side has more to say. The old version put two link cards in a third of the width and let
 * them float at whatever height they came out at.
 */
export const twoColumnSx: SxProps<Theme> = {
    display: 'grid',
    gridTemplateColumns: {xs: '1fr', lg: '8fr 4fr'},
    gap: 2,
    alignItems: 'stretch',
};
